import { motion } from "framer-motion"
import { TRANSITION } from "@/shared/lib/motion"
import { Skeleton } from "@/shared/ui/skeleton"

const number = new Intl.NumberFormat("ru-RU")

/**
 * Горизонтальные полосы с подписью и числом: для долей по категориям. Один цвет,
 * потому что сравнивается величина, а не принадлежность к ряду.
 */
export function BarList({
	items,
	empty = "Данных пока нет",
}: {
	items: Array<{ key: string; label: string; value: number; hint?: string }>
	empty?: string
}) {
	const max = Math.max(1, ...items.map((item) => item.value))
	const total = items.reduce((sum, item) => sum + item.value, 0)
	if (items.length === 0) return <p className="text-sm text-muted-foreground">{empty}</p>
	return (
		<ul className="space-y-2.5">
			{items.map((item, index) => (
				<li key={item.key} className="group" title={item.hint}>
					<div className="mb-1 flex items-baseline justify-between gap-3 text-sm">
						<span className="truncate">{item.label}</span>
						<span className="shrink-0 tabular-nums">
							{number.format(item.value)}
							<span className="ml-1.5 text-xs text-muted-foreground">
								{total ? Math.round((item.value / total) * 100) : 0}%
							</span>
						</span>
					</div>
					<div className="h-2 overflow-hidden rounded-full bg-secondary">
						<motion.div
							className="h-full rounded-r-[4px] bg-[#3987e5]"
							initial={{ width: 0 }}
							animate={{ width: `${(item.value / max) * 100}%` }}
							transition={{ ...TRANSITION.slow, delay: index * 0.03 }}
						/>
					</div>
				</li>
			))}
		</ul>
	)
}

/** Заглушка полос: подпись с числом и полоса на каждой строке, как у самого списка. */
export function BarListSkeleton({ rows = 4 }: { rows?: number }) {
	return (
		<ul aria-hidden="true" className="space-y-2.5">
			{Array.from({ length: rows }, (_, index) => (
				<li key={index}>
					<div className="mb-1 flex h-5 items-center justify-between gap-3">
						<Skeleton className="h-3.5 rounded" style={{ width: `${62 - ((index * 17) % 30)}%` }} />
						<Skeleton className="h-3.5 w-14 rounded" />
					</div>
					<Skeleton className="h-2 rounded-full" style={{ width: `${92 - index * 18}%` }} />
				</li>
			))}
		</ul>
	)
}
